import {Injectable} from '@angular/core';
import {Deposit, DepositState} from '../services/deposit/deposit.model';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import * as FileSaver from 'file-saver';
import {DepositService} from 'app/archivage/common/services/deposit/deposit.service';
import {MatDialog} from '@angular/material/dialog';
import {BelState} from "../services/bel/bel/bel.model";


@Injectable({
  providedIn: 'root'
})
export class HelperDeposit {
  depositState = DepositState;
  public static getClassColorBtnChip(status: DepositState | BelState) {
    return `btn-${HelperDeposit.getClassColor(status)}`;
  }
  public static getClassColor(status: DepositState | BelState) {
    let classe = '';
    switch (status) {
      case DepositState.DONE:
      case BelState.GOFORDESTRUCTION:
        classe = 'deposit-done';
        break;
      case DepositState.WAITING:
      case BelState.SENDTOAD:
      case BelState.SENDTOSERVICES:
        classe = 'deposit-waiting';
        break;
      case DepositState.DRAFT:
      case BelState.CONSTITUTION_REVISION:
        classe = 'deposit-draft';
        break;
      case DepositState.INCOMPLETE:
        classe = 'deposit-incomplete';
        break;
      case DepositState.ARCHIVED:
      case BelState.DESTROYED:
        classe = 'deposit-archived';
        break;
      default :
        classe = '';
    }
    return classe;
  }
  getEnumDepositStateKeys() {
    return Object.keys(this.depositState).filter(f => (!isNaN(Number(f))))
      .map(m => Number(m))
      .sort();
  }

  isDraftState(selectedEtat: number) {
    return (selectedEtat === this.depositState.DRAFT);
  }

  isValidatedState(selectedEtat: number) {
    return (selectedEtat === this.depositState.DONE);
  }

  isWaittingState(selectedEtat: number) {
    return (selectedEtat === this.depositState.WAITING);
  }

  isIncompleteState(selectedEtat: number) {
    return (selectedEtat === this.depositState.INCOMPLETE);
  }

  isArchivedState(selectedEtat: number) {
    return (selectedEtat === this.depositState.ARCHIVED);
  }

  getClassColor(status: DepositState) {
    return HelperDeposit.getClassColor(status);
  }
  getClassColorBtnChip(status: DepositState) {
    return HelperDeposit.getClassColorBtnChip(status);
  }

  exportBoxPdf(deposit: Deposit, depositSvc: DepositService, dialog: MatDialog) {
    const data = new DialogData();
    data.title = `Impression des descriptifs des boites`;
    data.message = '';
    const dialogRef = dialog.open(DialogValidationComponent, {data: data});
    dialogRef.updatePosition({top: '50px'});
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          depositSvc.exportBoxPdf(deposit).subscribe(
            (_data) => FileSaver.saveAs(_data, `${deposit.deposit_identifier}.pdf`)
          );
        }
      }
    );
  }
}
